import "./SC.css"; // Your responsive grid CSS
import maffick from "./img/maffick.png";
import aryan_saxena from "./img_sc/aryan_saxena.jpeg";
import raghvendra_singh from "./img_sc/raghvendra_singh.jpeg";
import kummari_siddharth from "./img_sc/kummari_siddharth.jpg";
import ayush_singh from './img_sc/ayush_singh.jpeg';
import aryan_baghel from './img_sc/aryan_sing_baghel.jpeg';
import shikhar_vijay from './img_sc/shikhar_vijay.jpeg';
import punit_kumar from './img_sc/punit_kumar.png';
import alen_joseph from './img_sc/alen_joseph.jpeg';
import harsh_rathore from './img_sc/harsh_rathore.jpeg';
import aditya_chauhan from './img_sc/aditya_chauhan.jpg';
import anish_pandit from './img_sc/anish_pandit.jpg';
import vaidik from './img_sc/vaidik_singh.jpeg';
import naman_sharma from './img_sc/naman_sharma.jpeg';
import discipline from './img_sc/discipline_sec.jpeg';
import raj_chouhan from './img_sc/raj_chouhan.jpeg';
import ankit from './img_sc/ankit_kumar_pandey.jpeg';
import aryan_patel from './img_sc/aryan_patel.jpeg';
function SC() {
  const profiles = [
    { name: "Ayush Singh", title: "President (Fourth Year, UG)", avatarUrl: ayush_singh },
    { name: "Raj Chouhan", title: "Vice-President (Fourth Year, UG)", avatarUrl: raj_chouhan },
    { name: "Naman Sharma", title: "Secretary Cultural (Fourth Year, UG)", avatarUrl: naman_sharma },
    { name: "Raghvendra Singh Gaur", title: "Secretary Technical (Fourth Year, UG)", avatarUrl: raghvendra_singh },
    { name: "Vaidik Singh Parihar", title: "Secretary (sports) (Fourth Year, UG)", avatarUrl: vaidik },
    { name: "G. Lakshmi Sri Rama", title: "Secretary Discipline (Fourth Year, UG)", avatarUrl: discipline },
    { name: "K. Siddharth", title: "Secretary Media (Fourth Year,UG)", avatarUrl: kummari_siddharth },
    { name: "Aryan Saxena", title: "General Secretary (Third Year, UG)", avatarUrl: aryan_saxena },
    { name: "Punit Kumar", title: "Treasurer (Third Year, UG)", avatarUrl: punit_kumar },
    { name: "Aryan Singh Baghel", title: "Secretary Alumni (Third Year, UG)", avatarUrl: aryan_baghel },
    { name: "Aditya Chauhan", title: "Joint-Secretary (Second Year,UG)", avatarUrl: aditya_chauhan },
    { name: "Anish Pandit", title: "Secretary (Literary, Hindi) (Second Year, UG)", avatarUrl: anish_pandit },
    { name: "Aryan Patel", title: "Secretary(Literacy,English) (Second Year, UG)", avatarUrl: aryan_patel },
    { name: "Harsh Rathore", title: "Executive Member, UG (1st Yr)", avatarUrl: harsh_rathore },
    { name: "Alen Joseph", title: "Executive Member, UG (1st Yr)", avatarUrl: alen_joseph },
    { name: "Shikhar Viyay", title: "Executive Member, MCA/MBA/B.TECH+M.TECH", avatarUrl: shikhar_vijay },
    { name: "Ambuj Kumar Dwivedi", title: "Executive Member (M.Tech/M.Plan/M.Arch)", avatarUrl: maffick },
    { name: "Ankit Kumar Pandey", title: "Executive Member, MA/MSc", avatarUrl: ankit },
    { name: "Virag Bohare", title: "Executive Member, Ph.D", avatarUrl: maffick },
    { name: "Vaibhav Goyal", title: "Ex-Member (Ex-Officio)", avatarUrl: maffick },
  ];

  return (
    <div className="pfp-container">
      <h2 className="sc-title">Student Council 2025-26</h2>
      <div className="pfp-row">
        {profiles.map((profile, index) => (
          <div key={index} className="pfp-card-wrapper">
            <div className="profile-card">
              <img 
                src={profile.avatarUrl} 
                alt={profile.name}
                className="profile-avatar"
              />
              <div className="profile-info">
                <h4>{profile.name}</h4>
                <p>{profile.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SC;
